import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getAssets, } from "shared/lib/constants/constants";
import { ACTIONS } from "./types";
import { formatBigNumber } from "shared/lib/utils/math";
import { getAssetDecimals, getAssetDisplay } from "shared/lib/utils/asset";
import WarningModalContent from "./WarningModalContent";
var WarningStep = function (_a) {
    var _b;
    var actionType = _a.actionType, withdrawOption = _a.withdrawOption, vaultOption = _a.vaultOption, vaultVersion = _a.vaultVersion, withdrawMetadata = _a.withdrawMetadata, onFormSubmit = _a.onFormSubmit;
    var asset = getAssets(vaultOption);
    // Standard withdraw warning for v2
    if (actionType === ACTIONS.withdraw &&
        withdrawOption === "standard" &&
        vaultVersion === "v2" &&
        !((_b = withdrawMetadata.instantWithdrawBalance) === null || _b === void 0 ? void 0 : _b.isZero())) {
        return (_jsx(WarningModalContent, { descriptionText: "\n        You can withdraw " + formatBigNumber(withdrawMetadata.instantWithdrawBalance, getAssetDecimals(asset)) + " " + getAssetDisplay(asset) + " immediately via instant withdrawals because these funds have not yet been deployed in the vault\u2019s strategy", onButtonClick: onFormSubmit }, void 0));
    }
    return _jsx(_Fragment, {}, void 0);
};
export default WarningStep;
//# sourceMappingURL=WarningStep.js.map